import React from "react";
import * as styles from "./velavu-alert-modal-object.module.scss";

export interface VelavuAlertModalObjectProps {
	children?: React.ReactNode;
}

/**
 * Displays content in large, centered blue text within a VelavuAlertModal.
 * Useful for highlighting the subject of an action (e.g., the name of an item being deleted).
 *
 * @example
 * <VelavuAlertModal>
 *   <VelavuAlertModalTitle>Delete the following site?</VelavuAlertModalTitle>
 *   <VelavuAlertModalObject>{siteName}</VelavuAlertModalObject>
 *   <VelavuAlertModalContent>
 *     The site and all associated data will be permanently deleted.
 *   </VelavuAlertModalContent>
 *   <VelavuAlertModalActions>
 *     ...
 *   </VelavuAlertModalActions>
 * </VelavuAlertModal>
 */
export default function VelavuAlertModalObject(
	props: VelavuAlertModalObjectProps,
) {
	return <div className={styles.object}>{props.children}</div>;
}
